export default __webpack_public_path__ + "a646e2869962528c9eb347af08a4dfa7.ttf";